import { memo } from "react";
import {
  AC_OPTIONS,
  AIRBAGS_OPTIONS,
  EQUIPMENT_ADDITIONAL,
  EQUIPMENT_ANTI_THEFT,
  EQUIPMENT_COMFORT,
  EQUIPMENT_SAFETY,
  RADIO_OPTIONS,
} from "services/api/sales/listings/consts";
import { ChipItem, MarketplaceDetails } from "services/api/sales/listings/types";
import { ChipGroupTitle, ChipToggle } from "ui/modules/sales/pages/listings/components/ListingEditCard/components/MarketplaceStep/primitives";
import { EmptyHint, InfoCard, Section } from "./primitives";

interface Props {
  details?: MarketplaceDetails | null;
}

const labelFor = (opts: { value: string; text: string }[], code: string | null | undefined) => {
  if (!code) return null;
  return opts.find((o) => o.value === code)?.text ?? code;
};

// Isti popis kao na unosu, samo bez klika — sva oprema je vidljiva, a odabrana
// je označena. Tako se detalj i wizard čitaju jednako.
const ChipList: React.FC<{ items: ChipItem[]; selected: Record<string, boolean> }> = ({ items, selected }) => (
  <div className="flex flex-col gap-2">
    {items.map((item) => (
      <ChipToggle key={item.code} label={item.label} selected={!!selected[item.code]} block readOnly />
    ))}
  </div>
);

// Sekcija "Oprema" — raspored preslikava EquipmentSection iz wizarda
// (Dodatna oprema | Sigurnost + protiv krađe + zračni jastuci | Udobnost + klima + radio).
const ListingEquipment: React.FC<Props> = ({ details }) => {
  if (!details) {
    return (
      <Section title="Oprema">
        <EmptyHint text="Oprema još nije unesena za ovaj oglas." />
      </Section>
    );
  }

  const selected = details.equipment ?? {};

  return (
    <Section title="Oprema">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <ChipGroupTitle>Dodatna oprema</ChipGroupTitle>
          <ChipList items={EQUIPMENT_ADDITIONAL} selected={selected} />
        </div>

        <div>
          <ChipGroupTitle>Sigurnost</ChipGroupTitle>
          <ChipList items={EQUIPMENT_SAFETY} selected={selected} />

          <div className="mt-4">
            <ChipGroupTitle>Sigurnost protiv krađe</ChipGroupTitle>
            <ChipList items={EQUIPMENT_ANTI_THEFT} selected={selected} />
          </div>

          <div className="mt-4">
            <InfoCard label="Zračni jastuci" value={labelFor(AIRBAGS_OPTIONS, details.airbagsCode)} />
          </div>
        </div>

        <div>
          <ChipGroupTitle>Udobnost</ChipGroupTitle>
          <ChipList items={EQUIPMENT_COMFORT} selected={selected} />

          <div className="mt-4 space-y-3">
            <InfoCard label="Klimatizacija" value={labelFor(AC_OPTIONS, details.airConditioningCode)} />
            <InfoCard label="Autoradio" value={labelFor(RADIO_OPTIONS, details.carRadioCode)} />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default memo(ListingEquipment);
